import React from 'react';

import { GraphQLProvider } from 'src/core/modules/bookkeep';

import { BookkeepingEditPayablesAfterExportSection } from './BookkeepingEditPayablesAfterExportSection';
import { BookkeepingStartDateSection } from './BookkeepingStartDateSection';

export const BookkeepingSetupSectionContainer = () => {
  return (
    <GraphQLProvider>
      <div className="flex w-full max-w-lg flex-col gap-32 self-center">
        <BookkeepingStartDateSection />

        <div className="separator" />

        <BookkeepingEditPayablesAfterExportSection />
      </div>
    </GraphQLProvider>
  );
};
